import { deleteArtTalle, getArtTallesPanel,postArtTalle } from "../../services/ArticulosTallesServices";
import { ArticulosTallesContext } from "./ArticulosTallesContext"

export const ArticulosTallesState = ({ children }) => {
    const getArtTallesPanelData = async (searchRam,searchTerm, page, perPage) => {
        let res = await getArtTallesPanel(searchRam,searchTerm, page, perPage)
        return res;
    }

    const deleteArticuloTalleData = async (body) => {
        const res = await deleteArtTalle(body)
        return res
    }

    const postArticuloTalleData = async (body) => {
        const res = await postArtTalle(body)
        return res
    }
    return <ArticulosTallesContext.Provider value={{
        deleteArticuloTalleData,
        postArticuloTalleData,
        getArtTallesPanelData
    }} >
        {children}
    </ArticulosTallesContext.Provider>
}